import moment from 'moment'
import {ReservationPeriod, ReservePaymentCalculatorDuration} from './ReservePaymentCalculatorDuration'
import {BusinessScheduleWithDateTime} from '../ReserveFacilityPaymentModel'
import {ReserveOptionPaymentCalculator} from './ReserveOptionPaymentCalculator'
import {BusinessSchedule} from '../../facilities/FacilityForReservation'

export class ReservePaymentCalculatorDurationNormal extends ReservePaymentCalculatorDuration {
    constructor(
        businessSchedules: BusinessScheduleWithDateTime[],
        startMoment: moment.Moment | null,
        endMoment: moment.Moment | null,
        optionCalculator: ReserveOptionPaymentCalculator,
    ) {
        super(businessSchedules, startMoment, endMoment, optionCalculator)
    }

    protected adjustPeriodBySchedule(
        schedule: BusinessScheduleWithDateTime | BusinessSchedule,
        period: ReservationPeriod,
    ): ReservationPeriod {
        const scheduleWithDateTime = schedule as BusinessScheduleWithDateTime
        const {start: startMoment, end: endMoment} = period

        const adjustedStart = (scheduleWithDateTime.startDateMoment < startMoment)
            ? startMoment
            : scheduleWithDateTime.startDateMoment
        const adjustedEnd = (endMoment < scheduleWithDateTime.endDateMoment)
            ? endMoment
            : scheduleWithDateTime.endDateMoment

        return {start: adjustedStart, end: adjustedEnd}
    }

    isEnableCalculate(): boolean {
        return super.isEnableCalculate()
    }
}
